<template>
<div class="d-lg-flex flex-row-fluid">
    <div class="flex-column offcanvas-mobile w-300px w-xl-325px">
        <div class="card card-custom gutter-b">
            <div class="card-header border-0 py-5">
                <h3 class="card-title align-items-start flex-column">
                    <span class="card-label font-weight-bolder text-dark"> Resumen de participación </span>
                    <span class="text-muted mt-3 font-weight-bold font-size-sm"></span>
                </h3>
            </div>
            <el-progress type="dashboard" :percentage="allAthlete" class="my-6">
                <template #default="{ percentage }">
                    <span class="percentage-value">{{ percentage }}</span>
                    <span class="percentage-label font-weight-bolder">Deportistas</span>
                </template>
            </el-progress>
            <apexchart type="bar" height="250" :options="chartOptions" :series="series" class="mr-10 w-300px"></apexchart>
        </div>
    </div>

    <div class="flex-row-fluid ml-lg-8">
        <div class="card card-custom">
            <div class="card-header flex-wrap border-0 pt-6 pb-0">
                <h3 class="card-title align-items-start flex-column">
                    <span class="card-label font-weight-bolder font-size-h3">Acreditar Deportistas</span>
                    <span class="text-muted mt-1 font-weight-bold font-size-sm"></span>
                </h3>
                <div class="card-toolbar w-sm-100 w-md-75 w-lg-50">
                        <el-select v-model="formFilter.idevent" placeholder="Seleccione un evento" size="medium" class="w-100" @change="getSports">
                            <el-option v-for="item in listEvents" :key="item.idevent"  :label="item.name" :value="item.idevent"></el-option>
                        </el-select>
                </div>
            </div>

            <div class="card-body">
                <el-empty v-if="listSports.length==0" :image-size="360"></el-empty>
                <div v-else class="card-columns mb-4">
                    <div class="card shadow hover-shadow card-hover" v-for="item in listSports" :key="item" @click="goSportView(item.idsport, item.tagform)">
                        <div :class="'card-header text-white h3 text-center ' + ( item.mstatus == 'O' ? 'bg-primary' : 'bg-danger')">{{item.name}}</div>
                        <div class="card-body">
                            <div class="d-flex flex-row">
                                <div class="p-2">
                                    <el-image :src="item.logo" class="card-img-top w-75">
                                        <template #placeholder>
                                            <div class="image-slot">Cargando<span class="dot">...</span></div>
                                        </template>
                                    </el-image>
                                </div>
                                <div class="p-2 text-center">
                                    <div class="display-2">{{item.total}}</div>
                                    <span class="label label-secondary label-inline">registrados</span>
                                </div>
                            </div>
                            <blockquote class="blockquote mb-0">
                                <footer class="blockquote-footer">
                                    <small class="text-muted">
                                        {{item.mstatus == 'O' ? 'Finaliza el ' + item.date_end : 'Inscripciones finalizadas.'}}
                                    </small>
                                </footer>
                            </blockquote>
                        </div>
                    </div>
                </div>
                
            </div>

        </div>
    </div>

</div>
</template>

<script>
import { mapGetters } from "vuex";
import { ACREDITATION } from "@/store/acreditation.module";
import {ADD_BODY_CLASSNAME, REMOVE_BODY_CLASSNAME} from "@/store/htmlclass.module.js";
import code from "@/core/config/status.code";

//services
import { UniService, AuthenticationError } from '@/core/services/uni.service';

//components
import VueApexCharts from 'vue3-apexcharts';

export default {
    name: 'athlete',
    components: { apexchart: VueApexCharts},
    data: () => ({
        listEvents: [],
        listSports: [],
        eventFilters: [],
        allAthlete: 0,
        formFilter: {idgroup:0, idevent: null,idsport: null},
        series: [{name: 'Deportistas',data: []}],
        chartOptions: {
            chart: {type: 'bar', height: 250},
            plotOptions: {
                bar: {borderRadius: 4,horizontal: true}
            },
            dataLabels: {enabled: false},
            xaxis: {categories: []},
        },
        bgImage: null
    }),
    computed: {
        ...mapGetters(['currentAcreditation', 'layoutConfig']),
    },
    methods:{
        async getEvents(){
            try {
                this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
                const res = await UniService.Events();
                this.listEvents = res.data.events;
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
            } catch (e) {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                if (e instanceof AuthenticationError) {
                    this.$alert( e.message.data !='' ? e.message.data.messages.error : e.message.statusText, 'Error ' +  e.errorCode, {
                        type: 'warning',
                        confirmButtonText: 'Entendido',
                        callback: action => {
                            code.Manager(e.errorCode);
                        }
                    });
                }
            }
        },
        async getSports(){
            try {
                this.allAthlete = 0;
                this.series[0].data.slice();
                this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
                const res = await UniService.Sports(this.formFilter.idevent);
                this.listSports = res.data;
                
                this.listSports.forEach(element => {
                    this.allAthlete += parseInt( element.total );
                    this.series[0].data.push(element.total);
                    this.chartOptions.xaxis.categories.push(element.name);
                });
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
            } catch (e) {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
                if (e instanceof AuthenticationError) {
                    this.$alert( e.message.data !='' ? e.message.data.messages.error : e.message.statusText, 'Error ' +  e.errorCode, {
                        type: 'warning',
                        confirmButtonText: 'Entendido',
                        callback: action => {
                            code.Manager(e.errorCode);
                        }
                    });
                }
            }
        },
        goSportView(id, tag){
            if(tag == null || tag == '')
                return this.$message.error('Lo sentimos, la vista se encuentra en mantenimiento');
            this.formFilter.idsport = id;
            this.$store.dispatch(ACREDITATION, this.formFilter);
            this.$router.push({ name: tag})
        },
    },
    created(){
        this.bgImage = this.layoutConfig("self.body.background-image")
        document.body.style.backgroundImage = `url(${this.bgImage})`;
        this.getEvents();
    }
}
</script>
<style scoped>

.time {
    font-size: 13px;
    color: #999;
  }
.el-progress--circle, .el-progress--dashboard {
    margin: 0px auto;
}
.el-progress .percentage-value {
    display: block;
    margin-top: 10px;
    font-size: 28px;
}
.el-progress .percentage-label {
    display: block;
    margin-top: 10px;
    font-size: 12px;
}
</style>
